<div class="govuk-grid-row asc__pagination-wrapper__vertical-align-center">
  <ng-content select="[placeAboveSearchBox]"></ng-content>

  @if (totalCount > itemsPerPage) {
    <div class="govuk-grid-column-three-quarters govuk-form-group" data-testid="search">
      <ng-content select="[overrideSearchBox]">
        <app-search-input
          ref="search"
          [accessibleLabel]="accessibleLabel"
          [label]="label"
          [prevSearch]="searchTerm"
          (emitInput)="handleSearch($event)"
        ></app-search-input>
      </ng-content>
    </div>
  }
  @if (count > 1) {
    <div
      [formGroup]="form"
      data-testid="sortBy"
      id="sort-by-container"
      class="govuk-grid-column-one-quarter govuk-!-margin-bottom-0 govuk-!-padding-top-2 govuk-!-padding-bottom-2 govuk-util__float-right"
    >
      <div class="govuk-form-group">
        <label class="govuk-label" for="sortBy"> Sort by </label>
        <select class="govuk-select govuk-!-width-full" id="sortBy" name="sortBy" formControlName="sortBySelected">
          @for (option of sortOptions | keyvalue; track option.key) {
            <option value="{{ option.key }}">
              {{ option.value }}
            </option>
          }
        </select>
      </div>
    </div>
  }
</div>
<div>
  <ng-content></ng-content>
  <app-pagination
    [itemsPerPage]="itemsPerPage"
    [totalNoOfItems]="count"
    (currentPageIndexChange)="handlePageUpdate($event)"
    [currentPageIndex]="currentPageIndex"
  ></app-pagination>
</div>
